import { defineStore } from 'pinia'
import { type IApiInstance } from '../plugins/api'

export type ICMSState = {
  isLoaded: boolean
  relationShip: any[]
  contactRelationships: any[]
  chartFilterObservationCode: any[]
  scoreObservationCode: any[]
  api: IApiInstance
}

export const useCMSStore = defineStore('cms', {
  state: (): ICMSState => {
    return {
      isLoaded: false,
      relationShip: [],
      contactRelationships: [],
      chartFilterObservationCode: [],
      scoreObservationCode: [],
      api: useNuxtApp().$api as IApiInstance,
    }
  },
  getters: {
    getRelationship: async (state) => {
      if (state.relationShip.length === 0) {
        state.relationShip = await state.api.cms.getRelationship()
      }
      return state.relationShip
    },
    getContactRelationships: async (state) => {
      if (state.contactRelationships.length === 0) {
        state.contactRelationships = await state.api.cms.get('patients_contacts_relationships', `fields[]=*`)
      }
      return state.contactRelationships
    },
    getChartFilterObservationCode: async (state) => {
      if (state.chartFilterObservationCode.length === 0) {
        state.chartFilterObservationCode = await state.api.cms.get(
          'patients_chart_filtersets',
          `fields[]=translations.name&fields[]=observations.observations_code`,
        )
      }
      return state.chartFilterObservationCode
    },
    getScoreObservationCode: async (state) => {
      if (state.scoreObservationCode.length === 0) {
        state.scoreObservationCode = await state.api.cms.get(
          'patients_chart_filtersets/af2fa863-6184-4bef-8bf3-b12667c41dd6',
          `fields[]=observations.observations_code`,
        )
      }
      return state.scoreObservationCode
    },
  },
  actions: {
    async load() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance

      const relationShip = await api.cms.getRelationship()
      const contactRelationships = await api.cms.get('patients_contacts_relationships', `fields[]=*`)
      const chartFilterObservationCode = await api.cms.get(
        'patients_chart_filtersets',
        `fields[]=translations.name&fields[]=observations.observations_code`,
      )

      const scoreObservationCode = await api.cms.get(
        'patients_chart_filtersets/af2fa863-6184-4bef-8bf3-b12667c41dd6',
        `fields[]=observations.observations_code`,
      )

      this.$patch({ isLoaded: true, relationShip, contactRelationships, chartFilterObservationCode, scoreObservationCode })
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
